<template>
  <v-container fluid>
    <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Actualización Masiva Compras Linea</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{on,attrs}">
                    <v-btn icon dark v-bind="attrs" v-on="on"><v-icon>mdi-help</v-icon></v-btn>
                </template>
                <span>
                    * Unicamente se actualizara la información INGRESADA es decir los campos que queden VACIOS mantendran la informacion que tengan PREVIAMENTE <br />
                    * Al agregar la información de POD se agrega de forma automatica el estatus OK por lo que no es necesario agregarlo de forma manual.
                </span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </section>
      <v-row>
        <v-col cols="3">
            <v-card rounded outlined>
                <v-card outlined elevation="3">
                    <v-card-title>Agregar guias separadas por coma(,)</v-card-title>
                    <v-card-text>
                        <v-textarea  label="Ingrese guías separadas por coma (,)" v-model="guiasComa" prepend-icon="mdi-file-multiple" @keyup.enter="addComa"></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="primary" @click="addGuiasporComas()">Agregar <v-icon dark>mdi-arrow-right</v-icon></v-btn>
                    </v-card-actions>
                </v-card>
            </v-card>
            <v-card rounded outlined elevation="3">
                <v-card-title>Agregar guías por criterio</v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col>
                            <v-text-field label="Guía Master" v-model="guia_master" clearable></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field label="No Vuelo" v-model="no_vuelo" clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-combobox
                                label="Operador"
                                :items="operadores"
                                v-model="operadorf"
                                item-text="operador"
                                item-value="operador"
                                return-object
                                clearable

                                ></v-combobox>
                        </v-col>
                        <v-col>
                            <v-combobox
                                label="Depot"
                                :items="depots"
                                v-model="depotf"
                                item-text="depot"
                                item-value="depot"
                                return-object
                                clearable

                                ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-combobox
                          v-model="provinciaf"
                          :items="provincias"
                          item-text="provincia"
                          item-value="provincia"
                          label="Provincia"
                          return-object
                          clearable
                        ></v-combobox>
                      </v-col>
                      <v-col>
                        <v-combobox
                          v-model="ciudadf"
                          :items="ciudades"
                          item-text="ciudad"
                          item-value="ciudad"
                          label="Ciudad"
                          return-object
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-text-field label="Referencia 1" v-model="referencia1" clearable></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field label="Referencia 2" v-model="referencia2" clearable></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6">
                            <v-text-field label="Referencia 3" v-model="referencia3" clearable></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="primary" @click="buscarGuiasPorCriterio()">Buscar <v-icon dark>mdi-file-find</v-icon></v-btn>
                    </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="3">
            <v-card rounded outlined elevation="3">
                <v-card-title>Guias a actualizar</v-card-title>
                <v-card-text>
                    <v-data-table :items="guiasActualizar" :headers="headers" class="elevation-3" :items-per-page="15">
                        <template v-slot:item.acciones="{item}">
                            <v-btn icon color="red" @click="eliminarGuiaActualizar(item)"><v-icon>mdi-delete-forever</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="6">
            <v-card rounded outlined elevation="3">
                <v-card-title>Información a actualizar</v-card-title>
                    <v-card-text>
                        <v-tabs vertical background-color="blue-grey lighten-5">
                            <v-tab>Información General</v-tab>
                            <v-tab>Estatus</v-tab>
                            <v-tab>POD</v-tab>
                            <v-tab>Información Importaciones</v-tab>
                            <v-tab>Transmitir a Tramaco</v-tab>
                            <v-tab>Transmitir a ServiEntrega</v-tab>
                            <v-tab-item>
                                <v-card>
                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                                <v-combobox
                                                label="Operador"
                                                :items="operadores"
                                                v-model="operador"
                                                item-text="operador"
                                                item-value="operador"
                                                return-object
                                                clearable
                                                append-icon="mdi-briefcase-account"
                                                ></v-combobox>
                                            </v-col>
                                            <v-col>
                                                <v-combobox
                                                label="Depot"
                                                :items="depots"
                                                v-model="depot"
                                                item-text="depot"
                                                item-value="depot"
                                                return-object
                                                clearable
                                                append-icon="mdi-map-marker-check"
                                                ></v-combobox>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Arribo"
                                                v-model="datos.fecha_arribo"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Liberación"
                                                v-model="datos.fecha_liberacion"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-radio-group v-model="datos.proceso" row label="Proceso">
                                                    <v-radio v-for="proc in procesos" :key="proc.value" :label="proc.text" :value="proc.value"></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-combobox
                                                label="Agente"
                                                :items="agentes"
                                                v-model="agente"
                                                item-text="nombre"
                                                item-value="id"
                                                return-object
                                                clearable
                                                append-icon="mdi-account"
                                                ></v-combobox>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Guía Agente"
                                                v-model="datos.guia_agente"
                                                clearable
                                                append-icon="mdi-earth"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-radio-group v-model="datos.no_controlado" row label="No Controlado">
                                                    <v-radio v-for="nc in noControlados" :key="nc.value" :label="nc.text" :value="nc.value"></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                label="Observación"
                                                v-model="datos.observacion"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card>
                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                                <v-combobox
                                                    v-model="estatus"
                                                    :items="lstEstatus"
                                                    label="Estatus"
                                                    item-value="id"
                                                    item-text="descripcion"
                                                    return-object
                                                    clearable
                                                ></v-combobox>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field
                                                type="date"
                                                v-model="datosEstatus.fecha"
                                                label="Fecha"
                                                clearable
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                type="time"
                                                v-model="datosEstatus.hora"
                                                label="Hora"
                                                clearable
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                    label="Comentarios"
                                                    v-model="datosEstatus.comentarios"
                                                    append-icon="mdi-file-edit"
                                                    clearable
                                                    ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card>
                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                            <v-text-field
                                                v-model="datos.pod_fecha"
                                                label="Fecha"
                                                type="date"
                                                clearable
                                            ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                    v-model="datos.pod_hora"
                                                    label="Hora"
                                                    type="time"
                                                    clearable
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                            <v-text-field
                                                v-model="datos.pod_nombre"
                                                label="Persona que recibe"
                                                append-icon="edit"
                                                clearable
                                            ></v-text-field>
                                            </v-col>
                                            <v-col>
                                            <v-text-field
                                                v-model="datos.pod_dni"
                                                label="DNI"
                                                append-icon="mdi-card"
                                                clearable
                                            ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <!--v-row>
                                            <v-col>
                                                <v-row>
                                                    <v-col class="d-flex child-flex" cols="10" sm="8" md="8">
                                                    <v-text-field
                                                        label="Archivo(s)"
                                                        readonly
                                                        v-model="imgUrl"
                                                        hint="Esta(s) imagen(es) se cargara(n) a las POD de cada una de las guías seleccionadas"
                                                        persistent-hint
                                                        clearable
                                                    ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2" sm="4" md="4">
                                                    <v-btn small color="primary" @click="pickFoto()" rounded outlined
                                                        >Seleccionar...<v-icon>mdi-folder-open</v-icon></v-btn
                                                    >
                                                    <input
                                                        type="file"
                                                        ref="filefoto"
                                                        style="display: none"
                                                        multiple
                                                        @change="onFotoPicked"
                                                    />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row-->
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Estimada Vuelo"
                                                v-model="datos.fecha_estimada_vuelo"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Declaracion"
                                                v-model="datos.fecha_declaracion"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col>
                                            <v-text-field
                                                label="Novedad Vuelo"
                                                v-model="datos.novedad_vuelo"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-text-field>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Tipo Aforo"
                                                v-model="datos.tipo_aforo"
                                                clearable
                                                append-icon="mdi-pencil-ruler"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Refrendo"
                                                v-model="datos.refrendo"
                                                clearable
                                                append-icon="mdi-file-document-edit"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Valor Declarado"
                                                v-model="datos.valor_declarado"
                                                clearable
                                                append-icon="mdi-cash"
                                                type="number"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Peso Ingresado Aduana"
                                                v-model="datos.peso_ingresado_aduana"
                                                clearable
                                                append-icon="mdi-scale-balance"
                                                type="number"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Categoria"
                                                v-model="datos.categoria"
                                                clearable
                                                append-icon="mdi-file-compare"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="MRN"
                                                v-model="datos.mrn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="MSN"
                                                v-model="datos.msn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="HSN"
                                                v-model="datos.hsn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Estatus Aduana"
                                                v-model="datos.estatus_aduana"
                                                clearable
                                                append-icon="mdi-earth-box-plus"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-textarea
                                                label="Causa Abandono"
                                                v-model="datos.causa_abandono"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-textarea>
                                            </v-col>
                                            <v-col>
                                                <v-textarea
                                                label="Novedad Inexpress"
                                                v-model="datos.novedad_inexpress"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card>
                                <v-card-text>
                                  <enviar-tramaco :guias="guiasActualizar"></enviar-tramaco>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card>
                                <v-card-text>
                                  <enviar-servi-entrega :guias="guiasActualizar"></enviar-servi-entrega>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                        </v-tabs>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small outlined color="primary" @click="actualizar()">Actualizar <v-icon dark>mdi-content-save</v-icon></v-btn>
                    </v-card-actions>
                </v-card>
        </v-col>
      </v-row>
      <v-dialog
          v-model="dialogBusqueda"
          transition="dialog-bottom-transition"
          persistent
          width="800"
          scrollable
          >
          <v-card elevation="24" outlined>
            <v-toolbar dark dense color="#96298A">
              <v-toolbar-title>Guías encontradas</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-divider vertical />
                <v-btn icon dark @click="closeModalBusqueda()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-divider vertical />
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-data-table :items="guiasEncontradas" :headers="headersEncontradas" class="elevation-3" :items-per-page="15">
                        <template v-slot:item.acciones="{item}">
                            <v-btn icon color="red" @click="eliminarGuiaEncontrada(item)"><v-icon>mdi-delete-forever</v-icon></v-btn>
                        </template>
                    </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small outlined color="primary" @click="agregarGuiasEncontradas()">Agregar <v-icon dark>mdi-arrow-right</v-icon></v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" scrollable>
        <v-card>
            <v-toolbar dark dense color="#96298A">
              <v-toolbar-title>Resultados</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-divider vertical />
                <v-btn icon dark @click="dialogResult = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-divider vertical />
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
          <v-card-text>
              <v-row>
                <v-col>
                  <!--json-viewer :value="resultados"></json-viewer-->
                  <v-expansion-panels>
                    <v-row>
                      <v-col>
                        <v-expansion-panel>
                          <v-expansion-panel-header color="#96298A" class="white--text">
                              Actualizaciones
                              <template v-slot:actions>
                              <v-icon color="white">
                                  mdi-menu-down
                              </v-icon>
                              </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content v-if="resultados.data">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>Guia</th>
                                  <th>Estado</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(value, key) in resultados.data.actualizaciones" :key="key">
                                  <td>{{ key }}</td>
                                  <td>{{ value }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </v-expansion-panel-content>
                          </v-expansion-panel>
                      </v-col>
                      <v-col>
                        <v-expansion-panel>
                          <v-expansion-panel-header color="#96298A" class="white--text">
                              Notificaciones
                              <template v-slot:actions>
                              <v-icon color="white">
                                  mdi-menu-down
                              </v-icon>
                              </template>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content v-if="resultados.data">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>Guia</th>
                                  <th>Estado</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(value, key) in resultados.data.notificaciones" :key="key">
                                  <td>{{ key }}</td>
                                  <td>{{ value }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </v-expansion-panel-content>
                          </v-expansion-panel>
                      </v-col>
                    </v-row>
                </v-expansion-panels>
                </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import JsonViewer from "vue-json-viewer";
import EnviarTramaco from '../components/EnviarTramaco.vue';
import EnviarServiEntrega from '../components/EnviarServiEntrega.vue';
export default {
    components:{
        JsonViewer,
        EnviarTramaco,
        EnviarServiEntrega
    },
    data(){
        return{
            guiasComa: null,
            guia_master: null,
            no_vuelo: null,
            operadorf: null,
            depotf: null,
            referencia1: null,
            referencia2: null,
            referencia3: null,
            depots: [
                {depot: "GYE"},
                {depot: "UIO"},
                {depot: "ECO"},
            ],
            operadores: [
                {operador: "AGENTE"},
                {operador: "INEXPRESS"}
            ],
            operador: null,
            depot: null,
            guiasActualizar: [],
            headers: [
                { text: "Guía Hija", value: "guia_hija" },
                { text: "Acciones", align: "end", value: "acciones", sortable: false },
            ],
            datos :{
                operador: null,
                depot: null,
                guia_agente: null,
                fecha_arribo: null,
                fecha_liberacion: null,
                proceso: null,
                id_agente: null,
                //tiempo_transito: null,
                no_controlado: null,
                observacion: null,
                pod_fecha: null,
                pod_hora: null,
                pod_nombre: null,
                pod_dni: null,
                fecha_estimada_vuelo: null,
                novedad_vuelo: null,
                fecha_declaracion: null,
                dias_habiles_declaracion: null,
                dias_habiles_liberacion: null,
                tipo_aforo: null,
                refrendo: null,
                mrn: null,
                msn: null,
                hsn: null,
                valor_declarado: null,
                peso_ingresado_aduana: null,
                categoria: null,
                causa_abandono: null,
                estatus_aduana: null,
                novedad_inexpress: null,
            },
            datosEstatus: {
                id_estatus: null,
                fecha: null,
                hora: null,
                comentarios: null
            },
            procesos: [
                {text: "Normal", value : true},
                {text: "Con Novedad", value : false},
            ],
            noControlados: [
                {text: "Si", value : true},
                {text: "No", value : false},
            ],
            agentes: [],
            agente: null,
            imgUrl: [],
            guiasEncontradas: [],
            headersEncontradas: [
                { text: "Guía Hija", value: "guia_hija" },
                { text: "Provincia", value: "provincia" },
                { text: "Ciudad", value: "ciudad" },
                { text: "Acciones", align: "end", value: "acciones", sortable: false },
            ],
            dialogBusqueda: false,
            lstEstatus: [],
            estatus: null,
            dialogResult : false,
            resultados: [],
            provincias: [],
            ciudades: [],
            provinciaf: null,
            ciudadf : null,
        }
    },
    watch:{
        operador: function(item){
            if(item){
                this.datos.operador = item.operador;
            }
        },
        depot: function(item){
            if(item){
                this.datos.depot = item.depot;
            }
        },
        agente: function(item){
            if(item){
                this.datos.id_agente = item.id;
            }
        },
        estatus: function(item){
            if(item){
                this.datosEstatus.id_estatus = item.id;
            }
        },
        provinciaf: function(item){
          if (item) {
            this.ciudadf = null;
            this.fillCiudades(item.provincia);
          }
        },
    },
    methods:{
        getAgentes: async function(){
            await apicon.getDataApi(apicon.getApiBaseUrl() + 'agente').then((result) => {
                this.agentes = result;
            });
        },
        pickFoto: function () {
            this.$refs.filefoto.click();
        },
        onFotoPicked: function (e) {
            const files = e.target.files;
            this.files = files;
            for (var i = 0; i <= files.length - 1; i++) {
            if (files[i] !== undefined) {
                if (files[i].name.lastIndexOf(".") <= 0) {
                return;
                }
                //this.imageFile = files[0];
                this.imgUrl.push(files[i].name);
            }
            }
        },
        addGuiasporComas: function(){
            let guias = this.guiasComa.split(',');
            if(guias.length == 1){//es porque no estan separadas por coma y probablemente por espacio
              guias = this.guiasComa.split('\n').filter(item => item.trim() !== '');
            }
            guias.forEach(guia => {
                if(guia != null && guia != ''){
                    this.guiasActualizar.push({guia_hija : guia});
                }
            });
            this.guiasComa = null;
        },
        eliminarGuiaActualizar: function(item){
            this.guiasActualizar.splice(this.guiasActualizar.findIndex((p) => p === item), 1);
        },
        buscarGuiasPorCriterio: async function(){
            if(this.guia_master == null &&
                this.no_vuelo == null &&
                this.operadorf == null &&
                this.depotf == null &&
                this.provinciaf == null &&
                this.ciudadf == null &&
                this.referencia1 == null &&
                this.referencia2 == null &&
                this.referencia3 == null
                ){
                    this.$swal("Seleccione al menos un criterio de busqueda");
            }else{
                await apicon.getDataApi(apicon.getApiBaseUrl() + 'buscarguiasclporcriterio?page=' + 1 +
                            (this.guia_master != null ? "&guia_master=" + this.guia_master : "") +
                            (this.no_vuelo != null ? "&no_vuelo=" + this.no_vuelo : "") +
                            (this.operadorf != null ? "&operador=" + this.operadorf.operador : "") +
                            (this.depotf != null ? "&depot=" + this.depotf.depot : "") +
                            (this.provinciaf != null ? "&provincia=" + this.provinciaf.provincia : "") +
                            (this.ciudadf != null ? "&ciudad=" + this.ciudadf.ciudad : "") +
                            (this.referencia1 != null ? "&referencia1=" + this.referencia1 : "") +
                            (this.referencia2 != null ? "&referencia2=" + this.referencia2 : "") +
                            (this.referencia3 != null ? "&referencia3=" + this.referencia3 : "")
                    ).then((result) => {
                        this.guiasEncontradas = result;
                        if(result.length > 0){
                            this.dialogBusqueda = true;
                        }else{
                            this.$swal("Sin resultados!"); // no se encotraron resultados
                        }
                    })
            }
        },
        closeModalBusqueda: function(){
            this.guiasEncontradas = [];
            this.dialogBusqueda = false;
        },
        eliminarGuiaEncontrada: function(item){
            this.guiasEncontradas.splice(this.guiasEncontradas.findIndex((p) => p === item), 1);
        },
        agregarGuiasEncontradas: function(){
            this.guiasEncontradas.forEach(guia => {
                this.guiasActualizar.push({guia_hija : guia.guia_hija});
            });
            this.guiasEncontradas = [];
            this.limpiarCriterios();
            this.dialogBusqueda = false;
        },
        actualizar:async function(){
            let datosGuia = this.datos;
            Object.keys(datosGuia).forEach(key => {
                if(datosGuia[key] === null) delete datosGuia[key]
            });
            let datos = {
                datos : datosGuia,
                estatus: this.datosEstatus,
                guias : this.guiasActualizar,

            }
            await apicon.saveDataApi(apicon.getApiBaseUrl() + 'updateguiascl',datos).then((result)=> {
                this.resultados = result;
                //this.dialogResult = true; //Ya no mostar el resultado
                this.$swal("Actualizado"); //Mostrar en lugar del resultado!
                this.limpiar();
            })
        },
        limpiar: function(){
            Object.keys(this.datos).forEach(key => {
                this.datos[key] = null
            });
            Object.keys(this.datosEstatus).forEach(key => {
                this.datosEstatus[key] = null
            });
            this.guiasActualizar = [];
            this.guiasComa = null;
            this.operador = null;
            this.depot = null;
            this.agente = null;
            this.estatus = null;
            this.limpiarCriterios();
        },
        limpiarCriterios: function(){
            this.guia_master = null;
            this.no_vuelo = null;
            this.operadorf = null;
            this.depotf = null;
            this.referencia1 = null;
            this.referencia2 = null;
            this.referencia3 = null;
        },
        getLstEstatus: function () {
        apicon
          .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
          .then((result) => {
            this.lstEstatus = result
          })
      },
      addComa: function(e){
        if (e.keyCode == '13') { e.preventDefault(); }
        this.guiasComa += ',';
        this.guiasComa = this.guiasComa.replace("\n","");
      },
      fillProvincias: async function () {
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
          .then((result) => {
            this.provincias = result;
          });
      },
      fillCiudades:async function (provincia) {
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
          .then((result) => {
            this.ciudades = result;
          });
      },
    },
    mounted: async function(){
        await apicon.setAuthHeaders();
        await this.getAgentes();
        this.getLstEstatus();
        await this.fillProvincias();
    }
}
</script>
